import { Box } from '@material-ui/core';
import { useState } from 'react';
import { useBusinessDetail } from '../../context/Business-context';
import { FlexBox } from '../Reusables';
import { colors } from '../InitialColor';
import { useHistory } from 'react-router-dom';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import styled from 'styled-components';
import SettingsIcon from '@material-ui/icons/Settings';
import defaultUser from '../../common/images/avatar.jpeg';
import Avatar from '@material-ui/core/Avatar';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BusinessListMenu from './MenuItem';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import RightSlide from 'HR/Timeoff/Drawer';
import HelpAndLearn from 'Info/HelpAndLearn';
import Notification from './Notification';
import { permissionList } from 'api/settings';
import { useQuery } from 'react-query';

export default function TopNavDrawer({
  state,
  setState,
  data,
  BusinessName,
  user,
  ctaClass
}) {
  const [openInfo, setOpenInfo] = useState(false);
  const [openNotif, setOpenNotif] = useState(false);

  const history = useHistory();
  const { data: businessDetails, queryClient } = useBusinessDetail();

  const toggleDrawer = () => {
    setState((open) => !open);
  };

  const handleCurrentBusiness = (id) => {
    if (id) {
      localStorage.setItem('business_domain', id);
      queryClient.refetchQueries(['business-detail']);
      window.location.replace('/dashboard');
    }
  };

  const handleSettings = () => {
    history.push('/settings?tab=company-info');
  };

  const handleAddBusiness = () => {
    history.push('/profile?tab=add-business');
  };

  const logOut = () => {
    localStorage.clear();
    queryClient.resetQueries('user', { refetch: false });
    history.push('/login');
  };
  const { data: permissionListData, isSuccess: successList } = useQuery(
    ['permission-list'],
    permissionList
  );
  const superAdminId = permissionListData?.results?.find(
    (item) => item.name === 'SuperAdmin'
  )?.id;
  const url = process.env.REACT_APP_MYEDGE_URL;
  return (
    <div className='TopNavDrawer'>
      <SwipeableDrawer
        anchor={'right'}
        open={state}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <>
          <RightSlide
            state={openInfo}
            setState={setOpenInfo}
            className='side-drawer3'
          >
            <HelpAndLearn state={openInfo} setState={setOpenInfo} />
          </RightSlide>
          <RightSlide
            state={openNotif}
            setState={setOpenNotif}
            className='side-drawer2'
          >
            <Notification closeModal={() => setOpenNotif(false)} />
            {/* {stages[stage]} */}
          </RightSlide>
        </>
        <TopNavDrawer.Wrapper>
          <Box className='summary'>
            <ChevronRightIcon
              htmlColor='#545454'
              onClick={toggleDrawer}
              id='pointer'
            />
            <FlexBox jc='normal' style={{ gap: 15 }}>
              <Avatar
                alt='business logo'
                src={BusinessName?.logo || defaultUser}
                className='medium'
              />
              <Box>
                {data && (
                  <>
                    <Typography variant='subtitle2'>
                      {`${businessDetails?.name}`}
                    </Typography>
                    <Typography variant='subtitle1'>{`${data.email}`}</Typography>
                  </>
                )}
              </Box>
            </FlexBox>
          </Box>
          <FlexBox className='heading-container'>
            <div className='heading'>Your Businesses</div>
          </FlexBox>

          <div className='businesses_list'>
            {data?.business_user_memberships.map((item) => (
              <Grid
                container
                alignItems='center'
                justify='flex-start'
                spacing={1}
                style={{ cursor: 'pointer' }}
                onClick={() => handleCurrentBusiness(item.business_id)}
                className='business-container'
              >
                <Grid item style={{ margin: '.3em 0px' }}>
                  {item?.logo ? (
                    <Avatar
                      alt='business logo'
                      src={item?.logo}
                      className='image'
                    />
                  ) : (
                    <Avatar
                      style={{
                        background: colors[item?.business_name.charAt(0)],
                        textTransform: 'capitalize'
                      }}
                      className='image'
                    >
                      {item?.business_name.charAt(0)}
                    </Avatar>
                  )}
                </Grid>
                <Grid item>
                  <Typography className='name'>
                    {item?.business_name}
                  </Typography>
                  {businessDetails?.business_id === item?.business_id && (
                    <Typography className='active'>Active</Typography>
                  )}
                </Grid>
                <Grid item>
                  <BusinessListMenu id={item?.business_id} />
                </Grid>
              </Grid>
            ))}
          </div>
          <div className='add-business' onClick={handleAddBusiness}>
            <div className='add'>
              <AddIcon />
            </div>{' '}
            <span>Add another business</span>
          </div>
          <MyEdgeWrapper className='my_edge'>
            <a href={url} target='_blank' rel='noreferrer'>
              <FlexBox>
                <Typography className='connect'>Connect Myedge</Typography>
                <NavigateNextIcon htmlColor='#4069D0' />
              </FlexBox>
            </a>

            <Typography className='info'>
              Opens MyEdge - The Employee Self Service App
            </Typography>
          </MyEdgeWrapper>

          {/* {isMobile && (
            <MobileMenuContainer>
              {' '}
              <MobileMenu
                onClick={toggleOpenInfo}
                style={{ cursor: 'pointer' }}
              >
                <ErrorIcon fontSize='medium' htmlColor='#545454' />
                <MobileTypography
                  style={{
                    fontFamily: 'Black Sans',
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}
                >
                  Help & Support
                </MobileTypography>
              </MobileMenu>
              <hr className='line' />
              <MobileMenu
                onClick={toggleOpenNotif}
                style={{ cursor: 'pointer' }}
              >
               

                <Badge
                  badgeContent={unreadCount?.count}
                  color='secondary'
                  onClick={clearAll}
                >
                  <NotificationsIcon />
                </Badge>

                <MobileTypography
                  style={{
                    paddingTop: '.2em',
                    fontFamily: 'Black Sans',
                    fontSize: '16px',
                    fontWeight: 'bold'
                  }}
                >
                  Notifications
                </MobileTypography>
              </MobileMenu>
            </MobileMenuContainer>
          )} */}
          <div className='bottom'>
            {user &&
              (user.is_owner ||
                user?.permissions?.some(
                  (permission) => permission.id === superAdminId
                )) && (
                <FlexBox
                  jc='normal'
                  style={{
                    gap: 12,
                    padding: 20,
                    borderTop: '1px solid #E1E1E1',
                    borderBottom: '1px solid #E1E1E1'
                  }}
                  id='pointer'
                  onClick={handleSettings}
                >
                  <SettingsIcon />
                  <Typography variant='subtitle2' className={ctaClass}>
                    Settings
                  </Typography>
                </FlexBox>
              )}{' '}
            <FlexBox
              jc='normal'
              style={{
                gap: 12,
                padding: 20,
                borderBottom: '1px solid #E1E1E1'
              }}
              id='pointer'
              onClick={logOut}
            >
              <ExitToAppIcon />
              <Typography variant='subtitle2' className={ctaClass}>
                Log out
              </Typography>
            </FlexBox>
          </div>
        </TopNavDrawer.Wrapper>
      </SwipeableDrawer>
    </div>
  );
}

TopNavDrawer.Wrapper = styled.div`
  position: relative;
  height: 100vh;
  /* overflow-y: scroll; */
  #pointer {
    cursor: pointer;
  }
  .heading-container {
    background: #eaf8fa;
    padding: 16px 13px 18px 20px;
    margin-bottom: 14px;
    .heading {
      font-weight: 400;
      font-size: 14px;
      line-height: 128.86%;
      color: #2898a4;
    }
    svg {
      width: 31.79px;
      height: 30px;
      cursor: pointer;
    }
  }

  .business-container {
    padding: 0px 23px 0px 20px;
    border-bottom: 1px solid #e1e1e1;
    position: relative;
    height: 72px;
    .image {
      width: 36px;
      height: 36px;
      border-radius: 10px;
    }
    .name {
      font-weight: 600;
      font-size: 18px;
      line-height: 128.86%;
      color: #171717;
      text-transform: capitalize;
    }
    .icon {
      position: absolute;
      right: 20px;
      top: 25px;
    }
  }
  .add-business {
    background: #fafafa;
    padding: 18px 42px 18px 20px;
    border-bottom: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    span {
      font-weight: 600;
      font-size: 18px;
      line-height: 128.86%;
      color: #545454;
    }
    .add {
      width: 36px;
      height: 36px;
      background: #e1e1e1;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .businesses_list {
    height: calc(100vh - 460px);
    overflow-y: scroll;
    .active {
      font-weight: 400;
      font-size: 14px;
      line-height: 128.86%;
      color: #2898a4;
    }
  }

  /* .bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
  } */
  .medium {
    width: 60px;
    height: 60px;
    margin: 0 !important;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
  }

  .summary {
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    & .MuiTypography-body1 {
      color: #545454;
      font-size: 18px;
      font-style: normal;
    }
    & .MuiTypography-subtitle2 {
      font-size: 22px;
      font-weight: 600;
      font-style: normal;
      text-align: left;
      line-height: 128.86%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: capitalize;
      color: #171717;
      width: 95%;
    }
    & .MuiTypography-subtitle1 {
      font-size: 14px;
      font-weight: 400;
      font-style: normal;
      text-align: left;
      line-height: 128.86%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #878787;
      width: 95%;
    }
    & .MuiAvatar-root {
      margin: auto;
    }
  }
`;

const MyEdgeWrapper = styled.div`
  background: #ebeffa;
  padding: 20px;
  .connect {
    font-weight: 600;
    font-size: 16px;
    line-height: 128.86%;
    color: #4069d0;
  }
  .info {
    font-weight: 400;
    font-size: 12px;
    line-height: 141.86%;
    color: #142652;
    text-align: left;
    margin-top: 10px;
  }
`;
